import { Tooltip as AlchemyTooltip } from '@m/alchemy-ui/Tooltip';
import { useIntl } from 'react-intl';
import { removeTags } from '../../../helpers';
import * as Styled from './IdeaCard.styled';

interface IdeaTitleProps {
  readonly ideaId: string;
  readonly title: string;
  readonly hasAccess: boolean;
}

export const IdeaTitle = ({ ideaId, title, hasAccess }: IdeaTitleProps) => {
  const intl = useIntl();
  const cleanTitle = removeTags(title || '');
  const noAccessMessage = intl.formatMessage({
    id: 'noAccessToItem',
    defaultMessage: 'You no longer have access to this item'
  });

  return (
    <Styled.IdeaTitle>
      {hasAccess ? (
        <a href={`/post/${ideaId}`} target="_top">
          {cleanTitle}
        </a>
      ) : (
        <AlchemyTooltip
          trigger={
            <Styled.DisabledText tabIndex={0} aria-label={`${noAccessMessage}: ${cleanTitle}`}>
              {cleanTitle}
            </Styled.DisabledText>
          }
          placement="top"
          contents={noAccessMessage}
        />
      )}
    </Styled.IdeaTitle>
  );
};
